import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { lessonsCount, sectionItems } from '../../../utility/coachCertification'
import ItemsRailItem from './ItemsRailItem'
import ProgressBar from './ProgressBar'

import classes from './ItemsRail.module.scss'

const ItemsRail = ({ certification, items, current, className }) => {
  const { t } = useTranslation()
  const quizMeta = (quiz) => t('portal.certification.item.quizMeta', { questions: quiz.questions.length, passMark: quiz.passMark })
  const lessonMeta = (lesson) => t(`portal.certification.item.${lesson.vimeoEmbedUrl ? 'video' : 'reading'}`)
  const finalItem = items.find(item => item.final)

  return (
    <aside className={classNames(classes.rail, className)}>
      <div className={classes.head}>
        <span className={classes.totals}>
          {t('portal.certification.item.totals', { sections: certification.sections.length, lessons: lessonsCount(certification) })}
        </span>
        <span className={classes.courseTitle}>{certification.name}</span>
        <ProgressBar
          done={certification.completedCount}
          total={certification.totalCount}
          label={`${certification.completedCount}/${certification.totalCount}`}
          className='mt-3'
        />
      </div>
      <div className={classes.list}>
        {certification.sections.map((section, sectionIndex) => (
          <div key={section.id}>
            <div className={classes.sectionTitle}>{sectionIndex + 1} · {section.title}</div>
            {sectionItems(items, section).map(item => (
              <ItemsRailItem
                key={`${item.type}-${item.id}`}
                item={item}
                title={item.type === 'lesson' ? item.lesson.title : t('portal.certification.item.sectionQuiz', { number: sectionIndex + 1 })}
                meta={item.type === 'lesson' ? lessonMeta(item.lesson) : quizMeta(item.quiz)}
                active={item === current}
              />
            ))}
          </div>
        ))}
        {finalItem && (
          <div className={classes.finalRow}>
            <ItemsRailItem
              item={finalItem}
              title={t('portal.certification.item.finalExam')}
              meta={quizMeta(finalItem.quiz)}
              active={finalItem === current}
            />
          </div>
        )}
      </div>
    </aside>
  )
}

ItemsRail.propTypes = {
  certification: PropTypes.shape({
    name: PropTypes.string.isRequired,
    sections: PropTypes.array.isRequired,
    completedCount: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
  }).isRequired,
  items: PropTypes.array.isRequired,
  current: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default ItemsRail
